import { Fragment, type ReactNode } from "react";

import Centered from "./Centered";
import Spacer from "./space/Spacer";
import { WithSpace } from "./space/WithSpace";
import Text from "./Text";

type EmptyViewProps = {
    message: string;
    callToAction?: ReactNode;
};

export default function EmptyView(props: EmptyViewProps) {
    const { message, callToAction } = props;
    return (
        <WithSpace all={8}>
            <Centered>
                <Text variant="body" align="center">
                    {message}
                </Text>
                {callToAction ? (
                    <Fragment>
                        <Spacer scale={3} />
                        <Centered>{callToAction}</Centered>
                    </Fragment>
                ) : null}
            </Centered>
        </WithSpace>
    );
}
